import { Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useStore } from "@/lib/store";
import { useXC } from "@/lib/hooks";
import AccountForm from "@/components/AccountForm";

function ActiveInfo({ acc }) {
  const { data } = useXC(acc, "", {});
  const u = data?.user_info;
  if (!u) return null;
  const exp = u.exp_date ? new Date(Number(u.exp_date) * 1000).toLocaleDateString() : "Never";
  return (
    <div className="grid grid-cols-3 gap-2 mt-3" data-testid="account-info">
      {[["Status", u.status], ["Expires", exp], ["Connections", `${u.active_cons ?? 0}/${u.max_connections ?? "-"}`]].map(([k, v]) => (
        <div key={k} className="rounded-lg bg-[#08090E] border border-[#212738] px-3 py-2">
          <div className="xc-label">{k}</div>
          <div className="text-sm font-mono text-slate-200 mt-0.5 truncate">{v}</div>
        </div>
      ))}
    </div>
  );
}

export default function AccountDialog({ open, onOpenChange }) {
  const { accounts, active, setActive, removeAccount, addAccount } = useStore();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#11141F] border-[#212738] text-slate-100 max-w-xl max-h-[90vh] overflow-y-auto" data-testid="account-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Playlists</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {accounts.map((a) => (
            <div
              key={a.id}
              className={`flex items-center gap-3 rounded-xl border px-4 py-3 ${a.id === active?.id ? "border-[#E50914]/60 bg-[#E50914]/5" : "border-[#212738]"}`}
              data-testid={`account-row-${a.id}`}
            >
              <button className="flex-1 text-left min-w-0" onClick={() => setActive(a.id)} data-testid={`account-select-${a.id}`}>
                <div className="font-medium truncate">{a.name}</div>
                <div className="text-xs font-mono text-slate-500 truncate">{a.server === "demo" ? "built-in demo" : a.server} · {a.username}</div>
              </button>
              {a.id === active?.id && <Check className="w-4 h-4 text-[#10B981]" />}
              <button
                onClick={() => {
                  removeAccount(a.id);
                  toast("Playlist removed");
                }}
                className="p-2 rounded-lg text-slate-500 hover:text-[#FF5A62] hover:bg-white/5"
                data-testid={`account-delete-${a.id}`}
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
          {active && <ActiveInfo acc={active} />}
        </div>
        <div className="border-t border-[#212738] pt-5 mt-2">
          <h3 className="font-heading text-lg mb-4">Add a playlist</h3>
          <AccountForm
            onSave={(a) => {
              addAccount(a);
              toast.success(`Connected to ${a.name}`);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
